import React, { useEffect, useState } from 'react';
import AuthService from '~/modules/services/auth-service';
import useAuth from '~/modules/hooks/use-auth';
import GuestAccessService from '~/modules/services/guest-access-service';
import Spinner from '~/modules/components/global/spinner';
import StorageService from '~/modules/services/storage-service';

const GuestAccessBootstrap = ({ children }) => {
	const { guestLogin } = useAuth();
	const [isBootstrapping, setIsBootstrapping] = useState(() => {
		return Boolean(GuestAccessService.getCodeFromUrl() && !AuthService.getToken());
	});

	useEffect(() => {
		let isActive = true;
		const guestCode = GuestAccessService.getCodeFromUrl();
		const destinationUrl = GuestAccessService.getDestinationUrl();

		if( !guestCode ) {
			setIsBootstrapping(false);
			return () => {
				isActive = false;
			};
		}

		if( AuthService.getToken() ) {
			GuestAccessService.removeCodeFromUrl();
			if( isActive ) {
				setIsBootstrapping(false);
			}
			return () => {
				isActive = false;
			};
		}

		const credentials = GuestAccessService.decodeCode(guestCode);

		if( !credentials ) {
			GuestAccessService.removeCodeFromUrl();
			if( isActive ) {
				setIsBootstrapping(false);
			}
			return () => {
				isActive = false;
			};
		}

		guestLogin({ ...credentials, redirect: false })
			.then(() => {
				window.location.replace(destinationUrl);
			})
			.catch(() => {
				// Fall back to the normal unauthenticated flow if bootstrap fails.
				StorageService.set('lastRoute', destinationUrl);
				GuestAccessService.removeCodeFromUrl();
				if( isActive ) {
					setIsBootstrapping(false);
				}
			});

		return () => {
			isActive = false;
		};
	}, [guestLogin]);

	if( isBootstrapping ) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20vh' }}>
				<Spinner medium />
			</div>
		);
	}

	return children;
};

export default GuestAccessBootstrap;
